import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { NavParams } from 'ionic-angular';

import { BestPage } from '../best/best';

@Component({
  selector: 'page-filter',
  templateUrl: 'filter.html'
})
export class FilterPage {

  types:Array<{}>
  renders:Array<{}>

  constructor(public navCtrl: NavController, private navParams: NavParams) {
    this.renders = navParams.get('renders');
    this.types = [
      {name:'Tamanho da Tela',img:'filter8.png',field:'feature1'},
      {name:'Câmera',img:'filter2.png',field:'feature2'},
      {name:'Processamento',img:'filter5.png',field:'feature3'},
      {name:'Memória RAM',img:'filter6.png',field:'feature4'},
      {name:'Armazenamento',img:'filter4.png',field:'feature5'},
      {name:'Bateria',img:'filter1.png',field:'feature6'},
      {name:'Sistema Operacional',img:'filter7.png',field:'feature7'},
      {name:'Preço',img:'filter3.png',field:'feature0'}
    ]

  }

  listarRenders() {
    this.navCtrl.pop();
  }

  showBest(field) {
    this.navCtrl.push(BestPage,{bests:this.renders.slice(0,3),best:field});
  }

}



// WEBPACK FOOTER //
// ./src/pages/filter/filter.ts